define('plugin/promotion/view/PromotionInvoiceInstanceListView',['require','marionette','plugin/promotion/view/PromotionInvoiceInstanceItemView'],function (require) {

    var Marionette = require('marionette');
    var PromotionInvoiceInstanceItemView = require('plugin/promotion/view/PromotionInvoiceInstanceItemView');

    /**
     * Promotion invoice instance list view
     *
     * @class PromotionInvoiceInstanceListView
     */
    return Marionette.CompositeView.extend({

        template: '#promotion_invoice_instance_list_view',
        childViewContainer: '#sb_invoice_promotion_list',
        childView: PromotionInvoiceInstanceItemView,
        childEvents: {
            'remove:promotion': 'removePromotion'
        },
        childViewOptions: function () {
            return {
                allowEdit: this.getOption('allowEdit')
            }
        },

        modelEvents: {
        },

        removePromotion: function (event, data) {
            this.triggerMethod('remove:promo:code', this.model, data.model);
        }

    });

});
